// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/storm-coming.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const stormComing: Score = {
  slug: "storm-coming",
  n: 30,
  title: "Storm Coming",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "D minor",
  fifths: -1,
  time: [4, 4],
  tempo: 96,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 12,
  barQuarters: 4.0,
  lowest: 38,
  highest: 81,
  hasLyrics: false,
  jasonNote: "The last of the new ones, and it wants everything you have: a minor key, an accidental to watch, both hands busy, and a big run up the middle. Start it quiet and let it build. Play the last chord like you mean it.",
  teaches: [
    "D minor",
    "the raised seventh as an accidental",
    "a two-octave run",
    "building from quiet to loud",
    "a final chord in both hands"
  ],
  background: "/sight-reading/bg/storm-coming.jpg",
  newForThisEdition: true,
  fillsGap: "Ties together the minor keys, accidentals and bass reading that the new pieces introduce, none of which the printed book covers.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 1, hand: "lh", start: 0.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 1, hand: "lh", start: 2.0, dur: 2.0, midi: 57, pitch: "A3", d: "half" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 2, hand: "rh", start: 4.0, dur: 2.0, midi: 76, pitch: "E5", d: "half" },
    { bar: 2, hand: "lh", start: 4.0, dur: 2.0, midi: 46, pitch: "Bb2", d: "half" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 74, pitch: "D5", d: "half" },
    { bar: 2, hand: "lh", start: 6.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 3, hand: "lh", start: 8.0, dur: 2.0, midi: 45, pitch: "A2", d: "half" },
    { bar: 3, hand: "rh", start: 9.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 3, hand: "lh", start: 10.0, dur: 2.0, midi: 52, pitch: "E3", d: "half" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 73, pitch: "C#5", d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 4.0, midi: 74, pitch: "D5", d: "whole" },
    { bar: 4, hand: "lh", start: 12.0, dur: 4.0, midi: 50, pitch: "D3", d: "whole" },
    { bar: 5, hand: "rh", start: 16.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 5, hand: "lh", start: 16.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 5, hand: "rh", start: 16.5, dur: 0.5, midi: 70, pitch: "Bb4", d: "eighth" },
    { bar: 5, hand: "rh", start: 17.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 5, hand: "rh", start: 17.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 5, hand: "rh", start: 18.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 5, hand: "lh", start: 18.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 5, hand: "rh", start: 18.5, dur: 0.5, midi: 77, pitch: "F5", d: "eighth" },
    { bar: 5, hand: "rh", start: 19.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth" },
    { bar: 5, hand: "rh", start: 19.5, dur: 0.5, midi: 81, pitch: "A5", d: "eighth" },
    { bar: 6, hand: "rh", start: 20.0, dur: 2.0, midi: 81, pitch: "A5", d: "half" },
    { bar: 6, hand: "lh", start: 20.0, dur: 2.0, midi: 46, pitch: "Bb2", d: "half" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 79, pitch: "G5", d: "half" },
    { bar: 6, hand: "lh", start: 22.0, dur: 2.0, midi: 46, pitch: "Bb2", d: "half" },
    { bar: 7, hand: "rh", start: 24.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 7, hand: "lh", start: 24.0, dur: 2.0, midi: 45, pitch: "A2", d: "half" },
    { bar: 7, hand: "rh", start: 25.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 7, hand: "lh", start: 26.0, dur: 2.0, midi: 45, pitch: "A2", d: "half" },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 73, pitch: "C#5", d: "quarter" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 74, pitch: "D5", d: "whole" },
    { bar: 8, hand: "lh", start: 28.0, dur: 4.0, midi: 50, pitch: "D3", d: "whole" },
    { bar: 9, hand: "rh", start: 32.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 9, hand: "lh", start: 32.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 9, hand: "rh", start: 33.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 9, hand: "lh", start: 33.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 9, hand: "rh", start: 34.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 9, hand: "lh", start: 34.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 9, hand: "rh", start: 35.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter" },
    { bar: 9, hand: "lh", start: 35.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 10, hand: "rh", start: 36.0, dur: 2.0, midi: 81, pitch: "A5", d: "half" },
    { bar: 10, hand: "lh", start: 36.0, dur: 1.0, midi: 46, pitch: "Bb2", d: "quarter" },
    { bar: 10, hand: "lh", start: 37.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 10, hand: "rh", start: 38.0, dur: 2.0, midi: 77, pitch: "F5", d: "half" },
    { bar: 10, hand: "lh", start: 38.0, dur: 1.0, midi: 46, pitch: "Bb2", d: "quarter" },
    { bar: 10, hand: "lh", start: 39.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 11, hand: "rh", start: 40.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 11, hand: "lh", start: 40.0, dur: 1.0, midi: 45, pitch: "A2", d: "quarter" },
    { bar: 11, hand: "rh", start: 41.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 11, hand: "lh", start: 41.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 11, hand: "rh", start: 42.0, dur: 1.0, midi: 73, pitch: "C#5", d: "quarter" },
    { bar: 11, hand: "lh", start: 42.0, dur: 1.0, midi: 45, pitch: "A2", d: "quarter" },
    { bar: 11, hand: "rh", start: 43.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 11, hand: "lh", start: 43.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 12, hand: "rh", start: 44.0, dur: 4.0, midi: 74, pitch: "D5", d: "whole" },
    { bar: 12, hand: "rh", start: 44.0, dur: 4.0, midi: 77, pitch: "F5", d: "whole", chord: true },
    { bar: 12, hand: "rh", start: 44.0, dur: 4.0, midi: 81, pitch: "A5", d: "whole", chord: true },
    { bar: 12, hand: "lh", start: 44.0, dur: 4.0, midi: 38, pitch: "D2", d: "whole" },
    { bar: 12, hand: "lh", start: 44.0, dur: 4.0, midi: 50, pitch: "D3", d: "whole", chord: true },
  ],
};
